export const question1 = [
  { label: 'Clinical Case Management',
    value: 1,
  },
  { label: 'Medication Visit',
    value: 2,
  },
  { label: 'Combined Medication and Psychotherapy',
    value: 3,
  },
  { label: 'Psychotherapy:Individual',
    value: 4,
  },
  { label: 'Psychotherapy:Group',
    value: 5,
  },
  { label: 'Psychotherapy:Couples/Family',
    value: 6,
  },
  { label: 'Diagnostic/Intake Evaluation',
    value: 7,
  },
  { label: 'Alcohol/Drug Visit (outpatient)',
    value: 8,
  },
  { label: 'Self-Help Groups',
    value: 9,
  },
  { label: 'Other Psychological Service',
    value: 10,
  },
]

export const question2 = [
  { label: 'Emergency Room Visit',
    value: 11,
  },
  { label: 'Crisis Team Visit',
    value: 12,
  },
  { label: 'Day Treatment Program',
    value: 13,
  },
  { label: 'Partial Hospitalization Program',
    value: 14,
  },
  { label: 'Alcohol/Drug Rehabilitation',
    value: 15,
  },
  { label: 'Inpatient Hospitalization',
    value: 16,
  },
]

export const no_yes = [
  {
    label: 'No',
    value: 0,
  }, {
    label: 'Yes',
    value: 1,
  },
]

export const type_provider = [
  {
    label: 'Medical Doctor (MD)',
    value: 1,
  }, {
    label: 'Psychiatrist (MD)',
    value: 2,
  }, {
    label: 'Psychologist (PhD)',
    value: 3,
  }, {
    label: 'Social Worker',
    value: 4,
  }, {
    label: 'Nurse',
    value: 5,
  }, {
    label: 'Professional Trainee',
    value: 6,
  }, {
    label: 'Unspecified therapist or counselor',
    value: 7,
  }, {
    label: 'Religious Leader (priest, minister, rabbi)',
    value: 8,
  }, {
    label: 'Other Provider (specify)',
    value: 9,
  }, {
    label: 'Peer Supporter (sponsor, congregational member)',
    value: 10,
  }, {
    label: 'Vocational Rehabilitation Counselor',
    value: 11,
  }, {
    label: 'Alternative Medicine Provider',
    value: 12,
  },
]

export const reason_service_q1 = [
  {
    label: 'Bipolar Disorder',
    value: 1,
  }, {
    label: 'Alcohol/ Drug Abuse',
    value: 2,
  }, {
    label: 'Physical problem',
    value: 3,
  }, {
    label: 'Other Mental Health Problem',
    value: 4,
  }, {
    label: 'Other',
    value: 5,
  }, {
    label: 'I do not know',
    value: 6,
  },
]

export const reason_service_q2 = [
  {
    label: 'Physical Problem (old)',
    value: 1,
  }, {
    label: 'Physical Problem (new)',
    value: 2,
  }, {
    label: 'Mental Health Problem',
    value: 3,
  }, {
    label: 'Bipolar Disorder',
    value: 4,
  }, {
    label: 'Alcohol/Drug Abuse',
    value: 5,
  }, {
    label: 'Other',
    value: 6,
  },
]
